import { styled } from '@mui/material';
import type { UIDefinitionContainerStyles } from '../../utils/styles.ts';

export const ItemContainer = styled('div')<{ fitContent?: boolean; styles?: UIDefinitionContainerStyles }>(({ fitContent, styles, theme }) => {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    width: fitContent ? '100%' : 'auto',
    [theme.breakpoints.up('md')]: {
      padding: '8px',
    },
    ...styles,
  };
});
